import { render, staticRenderFns } from "./guidelines.vue?vue&type=template&id=56bfeb70&"
import script from "./guidelines.vue?vue&type=script&lang=js&"
export * from "./guidelines.vue?vue&type=script&lang=js&"
import style0 from "./guidelines.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports